//#region src/types/icon.types.ts
var e = {
	Normal: "0 0 16 16",
	Medium: "0 0 24 24",
	MediumLarge: "0 0 32 32",
	Large: "0 0 48 48",
	Social: "0 0 50 50",
	XLarge: "0 0 88 88",
	XXLarge: "0 0 200 200"
}, t = {
	Normal: 16,
	Medium: 24,
	MediumLarge: 32,
	Large: 48,
	Social: 50,
	XLarge: 88,
	XXLarge: 200
}, n = {
	Rounded: "rounded",
	Active: "active",
	Disabled: "disabled"
};
//#endregion
export { t as IconSize, n as IconType, e as IconViewBox };
